<template>
  <div class="main-content-wrapper content-page">
    <div xs12>


      <h1 class="page-title">
        <template v-if="getLanguage() == 'en'">Report Card PDFs</template>
        <template v-if="getLanguage() == 'fr'">Bulletin des écoles PDFs</template>
      </h1>

      <p style="font-weight: bold;">British Columbia</p>
      <p>
        <ul style="list-style-type: none;">
          <li>Report Card on British Columbia's Elementary Schools 2026 (<a href="/pdf/bc-elementary-school-rankings-2026.pdf" target="_blank">pdf</a>)</li>
          <li>Report Card on British Columbia's Secondary Schools 2020 (<a href="/pdf/bc-secondary-school-rankings-2020-13658.pdf" target="_blank">pdf</a>)</li>
        </ul>
      </p>

      <p style="font-weight: bold;">Alberta</p>
      <p>
        <ul style="list-style-type: none;">
          <li>Report Card on Alberta's Elementary Schools 2024 (<a href="/pdf/report-card-on-alberta-elementary-schools-2024.pdf" target="_blank">pdf</a>)</li>
          <li>Report Card on Alberta's High Schools 2025 (<a href="/pdf/report-card-on-alberta-high-schools-2025.pdf" target="_blank">pdf</a>)</li>
        </ul>
      </p>

      <p style="font-weight: bold;">Ontario</p>
      <p>
        <ul style="list-style-type: none;">
          <li>Report Card on Ontario's Elementary Schools 2025 (<a href="/pdf/ontario-elementary-school-rankings-2025.pdf" target="_blank">pdf</a>)</li>
          <li>Report Card on Ontario's Secondary Schools 2025 (<a href="/pdf/ontario-secondary-school-rankings-2025.pdf" target="_blank">pdf</a>)</li>
        </ul>
      </p>

      <p style="font-weight: bold;">Québec</p>
      <p>
        <ul style="list-style-type: none;">
          <li>Bulletin des écoles Secondaires du Québec 2025 (<a href="/pdf/bulletin-des-ecoles-secondaires-du-quebec-2025.pdf" target="_blank">pdf - Français</a>)</li>
        </ul>
      </p>

      <p style="font-weight: bold;">Archive</p>
      <p>
        <a href="https://www.fraserinstitute.org/studies/school-report-cards/archive" target="_blank">
          <template v-if="getLanguage() == 'en'">School Report Cards Archive</template>
          <template v-if="getLanguage() == 'fr'">Archives des Bulletin des écoles</template>
        </a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    getLanguage() {
      return localStorage.getItem('language') || 'en';
    }
  }
}
</script>
